var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.0398C12.5 10.3038 10.5929 11.8158 9.24154 12.8872C8.65631 13.3528 8.17446 13.7339 8 14.14C7.75077 14.7198 7.22738 15.1998 6.5 15.1998C5.77261 15.1998 5.25015 14.7198 5 14.14C4.82461 13.7339 4.34461 13.3528 3.75754 12.8872C2.40708 11.8158 0.5 10.3028 0.5 7.0398C0.5 5.38485 1.13214 3.79769 2.25736 2.62746C3.38258 1.45723 4.9087 0.799805 6.5 0.799805C8.0913 0.799805 9.61742 1.45723 10.7426 2.62746C11.8679 3.79769 12.5 5.38485 12.5 7.0398ZM7.88461 7.0398C7.88461 7.42172 7.73874 7.78799 7.47907 8.05804C7.2194 8.32809 6.86722 8.4798 6.5 8.4798C6.13278 8.4798 5.78059 8.32809 5.52093 8.05804C5.26126 7.78799 5.11538 7.42172 5.11538 7.0398C5.11538 6.65789 5.26126 6.29162 5.52093 6.02157C5.78059 5.75152 6.13278 5.5998 6.5 5.5998C6.86722 5.5998 7.2194 5.75152 7.47907 6.02157C7.73874 6.29162 7.88461 6.65789 7.88461 7.0398Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.f1bfabb779fceb949f43396437d1ddb6.svg";
export { ForwardRef as ReactComponent };